import React from 'react'

import type { CategoryGridContentBlock } from '@library/api-menu-experience'
import { CategoryGrid } from '@library/menu-page'

import { useMenuExperienceCategoryNavigation } from '../menuExperienceNavigationContext'

type CategoryGridContentBlockWrapperProps = {
  contentBlock: CategoryGridContentBlock
}

export const CategoryGridContentBlockWrapper = ({
  contentBlock,
}: CategoryGridContentBlockWrapperProps) => {
  const { selectCategory } = useMenuExperienceCategoryNavigation()

  const onCategoryClick = (categoryId: string, slug: string, parentCategoryId?: string) => {
    selectCategory({ id: categoryId, slug }, 'browse', parentCategoryId)
  }

  return <CategoryGrid contentBlock={contentBlock} onCategoryClick={onCategoryClick} />
}
